import { render, staticRenderFns } from "./VideoTutorials.vue?vue&type=template&id=8644cfa8"
import script from "./VideoTutorials.vue?vue&type=script&lang=js"
export * from "./VideoTutorials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports